import { render, staticRenderFns } from "./TodoDetails.vue?vue&type=template&id=9b8c1da2"
import script from "./TodoDetails.vue?vue&type=script&lang=ts"
export * from "./TodoDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports